import React, { Component } from 'react';
import './LookBook.css';
import { Image } from 'pixboost-react';
import sizeMe from 'react-sizeme';
import pixboostConfig from '../../../config/pixboost';
import { breakPoints } from '../../../config/breakpoints';
import HotSpot from './HotSpot';

class LookBook extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeScreen: 'lg',
      screens: {
        sm: breakPoints.sm,
        md: breakPoints.md,
        lg: breakPoints.lg
      },
      hotspots: this.props.hotspots || {},
      images: this.props.images || {}
    };
    this.myRef = React.createRef();
  }

  calculateBreakpoint() {
    const width = window.innerWidth

    if (width >= breakPoints.lg) {
      return 'lg';
    }
    if (width < breakPoints.lg && width >= breakPoints.md) {
      return 'md';
    }
    if (width < breakPoints.md) {
      return 'sm';
    }
  }

  componentDidMount() {
    this.setState({ activeScreen: this.calculateBreakpoint() });
  }

  componentDidUpdate() {
    const { activeScreen } = this.state;
    const newBreakpoint = this.calculateBreakpoint();

    if (newBreakpoint !== activeScreen) {
      this.setState({ activeScreen: newBreakpoint });
    }
  }

  render() {
    const { title, className, imageBasePath } = this.props;
    const { activeScreen, hotspots, images } = this.state;

    return (
      <div className={className}>
        {Object.keys(images).length > 0 && (
          <div className={'frame'} id="frame" ref={this.myRef}>
            <Image
              src={imageBasePath + images[activeScreen]}
              alt={title}
              config={pixboostConfig}
              lazy={false}
            />

            {Object.entries(hotspots)
              .filter(([, hotspot]) => hotspot[activeScreen])
              .map(([sku, hotspot]) => (
                <HotSpot
                  key={sku}
                  sku={sku}
                  {...hotspot[activeScreen]}
                  activeScreen={activeScreen}
                />
              ))}
          </div>
        )}
      </div>
    );
  }
}

export default sizeMe({ monitorHeight: true })(LookBook);



// WEBPACK FOOTER //
// ./src/components/content-blocks/LookBook/LookBook.js